import coreApiClient from "@/providers/core-api/CoreApi"
const resourceName = "/v1/organisations"

export default {
  get(organisationId) {
    return coreApiClient.sendRequest("get", `${resourceName}/${organisationId}`, {})
  },
}
